/* eslint-disable @typescript-eslint/no-explicit-any */
import { generateErrorId } from './generate-error-id';

class AppError extends Error {
  context: string;

  constructor(message: string, context: string) {
    super(message);
    this.name = 'AppError';
    this.context = context;
  }
}

export const throwErrorWithId = (
  message: string,
  context: Record<string, unknown> = {}
): never => {
  throw new AppError(
    `${message} ${generateErrorId()}`,
    JSON.stringify(context, null, 2)
  );
};
